// services/sensorService.js
import { apiService } from './apiService';
import { API_CONFIG } from '../config/api';

class SensorService {
  async getSensorMeasurements(boxId, sensorId, params = {}) {
    const endpoint = API_CONFIG.ENDPOINTS.SENSOR_MEASUREMENTS(boxId, sensorId);
    const queryParams = new URLSearchParams(params).toString();
    const urlWithParams = queryParams ? `${endpoint}&${queryParams}` : endpoint;
    console.log('DEBUG: sensorService fetching URL:', `${apiService.baseURL}${urlWithParams}`);
    try {
      const data = await apiService.get(urlWithParams);
      console.log('DEBUG: sensorService fetch successful:', data);
      return data;
    } catch (error) {
      console.error('DEBUG: sensorService fetch failed:', error);
      throw error;
    }
  }
}
export const sensorService = new SensorService();